module.exports = __webpack_public_path__ + "img/11-3.e95d73d2.png";